import React from 'react';

export const fieldLabelStyle: React.CSSProperties = {
  fontSize: '0.75rem',
  fontWeight: 600,
  color: 'rgba(0,0,0,0.55)',
  textTransform: 'uppercase',
  letterSpacing: '0.02em',
  marginBottom: 4
};

const FieldBlock: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children
}) => (
  <div style={{ marginBottom: 14 }}>
    <div style={fieldLabelStyle}>{label}</div>
    <div>{children}</div>
  </div>
);

export default FieldBlock;
